import { Button, Typography } from "@/components/atoms";
import { useAppSelector } from "@/redux/hooks";
import { activeOperatorSelector } from "@/redux/slices/operator/selectors";
import { clsx } from "@/utils";
import { useNavigate } from "react-router-dom";
import { GeneralLogo } from "./GeneralLogo";

export interface GeneralHeaderProps extends React.HTMLAttributes<HTMLDivElement> {
  action?: "signUp" | "login" | "contact";
}

export const GeneralHeader = ({ action, className, ...props }: GeneralHeaderProps) => {
  const navigate = useNavigate();
  const operator = useAppSelector(activeOperatorSelector);
  const signUpEnabled = operator?.singleTenant ? (operator?.flags.clientSignUpsEnabled || operator?.flags.driverSignUpsEnabled) : true;

  const renderAction = () => {
    switch (action) {
      case "signUp":
        if (signUpEnabled) {
          return (
            <div className="flex flex-row items-center gap-x-4">
              <Typography className="hidden md:block">Don&apos;t have an account?</Typography>
              <Button variant="primary" size="md" onClick={() => navigate("/signup")}>Sign Up</Button>
            </div>
          );
        }
        break;
      case "login":
        return (
          <div className="flex flex-row items-center gap-x-4">
            <Typography className="hidden md:block">Already have an account?</Typography>
            <Button variant="secondary" size="md" onClick={() => navigate("/login")}>Login</Button>
          </div>
        );
      case "contact":
        return (
          <div className="flex flex-row items-center gap-x-4">
            <Typography className="hidden md:block">Contact us at <a href = "mailto:support@rideminder.com" className="text-primary underline">support@rideminder.com</a></Typography>
          </div>
        );
    }

    return null;
  };

  return (
    <header className={clsx("flex relative items-center justify-center top-0 py-6 px-2 border-y-[1px] border-x-0 border-neutral-mid-gray bg-white", className)} {...props}>
      <div className="flex flex-row w-full max-w-[1040px]">
        <GeneralLogo />
        {renderAction()}
      </div>
    </header>
  );
};
